module.exports = __webpack_public_path__ + "static/media/Tonado.678418c7.svg";